import { IExtraOption } from './types'

export const NOTHING: IExtraOption = Object.freeze({
  title: 'Nothing',
  kind: 'nothing',
  value: ''
})
export const SPACE: IExtraOption = Object.freeze({
  title: 'Space',
  kind: 'space',
  value: ' '
})
export const MINUS: IExtraOption = Object.freeze({
  title: 'Minus',
  kind: 'minus',
  value: '-'
})
export const PLUS: IExtraOption = Object.freeze({
  title: 'Plus',
  kind: 'plus',
  value: '+'
})
export const BRACKETS: IExtraOption = Object.freeze({
  title: '[]',
  kind: 'squareBrackets',
  value: '[]'
})
export const QUOTES: IExtraOption = Object.freeze({
  title: '" "',
  kind: 'quotes',
  value: '""'
})
export const CUSTOM: IExtraOption = Object.freeze({
  title: 'Custom',
  kind: 'custom',
  value: ''
})

export const SEPARATORS = [NOTHING, SPACE, MINUS, PLUS, CUSTOM]
export const WRAPPERS = [NOTHING, QUOTES, BRACKETS]
